import { useMemo, useState } from "react";
import { getFormattedDate } from "../../../../helpers/date-time-helper";
import { Col, Container, Row, Button } from "reactstrap";
import Separator from "../../../../components/Common/Separator/index";
import { TUser } from "../../../../common/types/user";
import InfoField from "../../../../components/Common/InfoField";
import defaultUserAvatar from "../../../../assets/svg/default-user-avatar.svg";
import useAuthUser from "../../../../common/hooks/authUser";
import EditUserModal from "../edit-user-modal";

interface Props {
    data: TUser | null;
}

const UserDetails = ({ data }: Props) => {
    const { isAdmin } = useAuthUser();
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const formattedCreatedDate = useMemo(() => data?.created ? getFormattedDate(data.created, "M/D/YYYY") : '-', [data?.created]);

    return (
        <>
            <Container fluid className="user-details mt-3">
                <Row>
                    <Col md={6} lg={4} xl={3} className="d-flex flex-column align-items-center mb-4">
                        <img
                            src={defaultUserAvatar}
                            className="mb-3"
                        />
                        <div className="created mt-3 fst-italic">User Since {formattedCreatedDate}</div>
                    </Col>
                    <Col className="d-flex flex-column">
                        <div className="d-flex justify-content-between align-items-start">
                            <h2 className="my-5">{data?.displayName}</h2>
                            {isAdmin && (
                                <Button
                                    color="primary"
                                    onClick={() => setIsEditModalOpen(true)}
                                    className="mt-5"
                                >
                                    Edit User
                                </Button>
                            )}
                        </div>

                        <InfoField title="Email:" value={data?.email} />
                    </Col>
                </Row>
                <Separator />
            </Container>
            {isAdmin && (
                <EditUserModal
                    isOpen={isEditModalOpen}
                    onToggle={() => setIsEditModalOpen(false)}
                    user={data}
                />
            )}
        </>
    );
};

export default UserDetails;
